import React from 'react';
import { HealthDisplayProps } from '../types';
import TTSToggle from './TTSToggle';

// HealthDisplay Component
const HealthDisplay = ({ playerHealth, aiHealth, onHelpClick, musicPaused, onToggleMusic }: HealthDisplayProps) => (
    <div className="health-display nes-container is-rounded">
        <div className="player-health">
            <span className="nes-text is-primary">Player: </span>
            {Array(playerHealth).fill(0).map((_, i) => (
                <i key={`player-heart-full-${i}`} className="nes-icon is-small heart"></i>
            ))}
            {Array(3 - playerHealth).fill(0).map((_, i) => (
                <i key={`player-heart-empty-${i}`} className="nes-icon is-small heart is-empty"></i>
            ))}
        </div>
        <div className="ai-health">
            <span className="nes-text is-error">AI: </span>
            {Array(aiHealth).fill(0).map((_, i) => (
                <i key={`ai-heart-full-${i}`} className="nes-icon is-small heart"></i>
            ))}
            {Array(3 - aiHealth).fill(0).map((_, i) => (
                <i key={`ai-heart-empty-${i}`} className="nes-icon is-small heart is-empty"></i>
            ))}
        </div>
        <div className="health-controls">
            <TTSToggle className="health-tts-toggle" />
            {onToggleMusic && (
                <button
                    onClick={onToggleMusic}
                    className={`nes-btn health-control-btn ${!musicPaused ? 'is-success' : 'is-error'}`}
                    aria-label={!musicPaused ? 'Pause music' : 'Play music'}
                    title={!musicPaused ? 'Music is ON' : 'Music is OFF'}
                >
                    🎵
                </button>
            )}
            {onHelpClick && (
                <button
                    onClick={onHelpClick}
                    className="nes-btn help-button health-control-btn"
                    aria-label="How to play"
                    title="How to play"
                >
                    ❓
                </button>
            )}
        </div>
    </div>
);

export default HealthDisplay;
